module.exports = __webpack_public_path__ + "img/Cercle2.be5dedfe.svg";